import { isEmpty } from '@/common/utils/Util';

export default {
  setDetail: (state, data) => {
    state.detail = data;
  },
  setInquiryList: (state, list) => {
    state.inquiryList = [...state.inquiryList, ...list];
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  setPageInfo: (state, info) => {
    Object.assign(state.pageInfo, info);
  },
  initPage: state => {
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.userNo = '';
    state.pageInfo.totalPage = 2;
    state.inquiryList = [];
  }
};
